import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const SaasRouteTree = lazy(() =>
  import("./pages/marketing/saas/SaasRouteTree.jsx").then((module) => ({
    default: module.SaasRouteTree,
  })),
);
const SignInPage = lazy(() => import("./pages/auth/SignInPage.jsx"));

function RouteLoadingFallback() {
  return <div className="authGate">Loading…</div>;
}

function withSuspense(element) {
  return <Suspense fallback={<RouteLoadingFallback />}>{element}</Suspense>;
}

// LocalPickr's routes: customer sign-in and sign-up, then the site's pages
// (SaasRouteTree). Offlico's addresses (/app, /upgrade, /tasks, /admin,
// /book/<slug>, /c/<code>, /forms, /address, /stripe, /support, /pricing,
// /blog ...) never render here: SiteDomainBoundary (src/main.jsx) sends them
// to https://www.offlico.com first, as Render's rules do server side.
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={withSuspense(<SignInPage />)} />
      <Route path="/signup" element={withSuspense(<SignInPage />)} />
      <Route
        path="*"
        element={<Suspense fallback={null}><SaasRouteTree /></Suspense>}
      />
    </Routes>
  );
}
